import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
    Box,
    Stepper,
    Step,
    StepButton,
    Breadcrumbs,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';

import { stageFromPath, stageRoute, WORKFLOW_STAGES } from './workflowStage';

// 現在地（ワークフローのどのステージか）と次の一手を明示するステッパー。
// 各ステージは既存 route への遷移リンクのみ。route 由来の見た目で、既存の操作可否ガードは変えない。
// 狭幅では簡易パンくずにフォールバックする。
export const WorkflowStepper: React.FC = () => {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const theme = useTheme();
    const narrow = useMediaQuery(theme.breakpoints.down('sm'));

    const info = stageFromPath(pathname);
    // tool 外（NotFound 等）では表示しない。
    if (!info) return null;
    const { tool, stageIndex } = info;
    const toolLabel = `${tool.toUpperCase()} 検討ツール`;

    if (narrow) {
        return (
            <Breadcrumbs aria-label="ワークフロー" sx={{ mb: 2 }}>
                <Typography variant="body2" color="text.secondary">
                    {toolLabel}
                </Typography>
                <Typography variant="body2" color="text.primary">
                    {WORKFLOW_STAGES[stageIndex].label}
                </Typography>
            </Breadcrumbs>
        );
    }

    return (
        <Box component="nav" aria-label="ワークフロー" sx={{ mb: 3 }}>
            <Stepper nonLinear activeStep={stageIndex} alternativeLabel>
                {WORKFLOW_STAGES.map((stage, i) => (
                    <Step key={stage.key} completed={false}>
                        <StepButton onClick={() => navigate(stageRoute(tool, i))}>
                            {stage.label}
                        </StepButton>
                    </Step>
                ))}
            </Stepper>
        </Box>
    );
};
